<template>

    <div id="container-full" class="container-full">

    </div>

</template>

<style>
</style>

<script>
import {mapMutations} from "vuex";
import api from "../api";
import {models} from "powerbi-client";
// import * as powerbi from 'powerbi-client';

export default {
  name: "powerBiViewer",
  data: () => ({
    EmbedReport: {
      type: "",
      embedReport: [
        {
          reportId: "",
          reportName: "",
          embedUrl: "",
        },
      ],
      embedToken: {
        token: "",
        tokenId: "",
        expiration: "",
      },
    },
  }),
  created() {
    this.url = api.Url;
    this.setBreadcrumb([
      {
        text: "Reports ",
      },
    ]);
    const s = (data) => {
      this.EmbedReport = data;
      let embedData = data;

      var reportContainer = document.getElementById("container-full");

      var layoutType = models.LayoutType.MobilePortrait;

      if (window.matchMedia("(orientation: portrait)").matches) {
        layoutType = models.LayoutType.MobilePortrait;
      }

      if (window.matchMedia("(orientation: landscape)").matches) {
        layoutType = models.LayoutType.MobilePortrait;
      }

      if(!this.mobileAndTabletCheck()){
        layoutType = models.LayoutType.Master;
      }

      var reportLoadConfig = {
        type: "report",
        tokenType: 1,

        // Enable this setting to remove gray shoulders from embedded report
        // settings: {
        //     background: models.BackgroundType.Transparent
        // }

        settings: {
          layoutType: layoutType
        }
      };

      //Update Breadcrumb to display what report is being viewed


      console.log("Embeded Data",embedData);
      console.log("Embed Report",this.EmbedReport);
      reportLoadConfig.accessToken = embedData.embedToken.token;

      // You can embed different reports as per your need
      reportLoadConfig.embedUrl = embedData.embedReport[0].embedUrl;

      // Use the token expiry to regenerate Embed token for seamless end user experience
      // Refer https://aka.ms/RefreshEmbedToken
      //var tokenExpiry = embedData.tokenExpiry;

      // Embed Power BI report when Access token and Embed URL are available
      // eslint-disable-next-line
      var report = powerbi.embed(reportContainer, reportLoadConfig);

      // Triggers when a report schema is successfully loaded
      report.on("loaded", function () {
        console.log("Report load successful");
      });

      // Triggers when a report is successfully embedded in   UI
      report.on("rendered", function () {
        console.log("Report render successful");
      });

      // Clear any other error handler event
      report.off("error");

      // Below patch of code is for handling errors that occur during embedding
      report.on("error", function (event) {
        var errorMsg = event.detail;

        // Use errorMsg variable to log error in any destination of choice
        console.error(errorMsg);
        this.makeToast("PowerBI",errorMsg,'da')
        return;
      });

      console.log(data);
    };

    const e = (msg) => {
      this.makeToast("PowerBI",msg,'warning')
      console.log(msg);
    };

    const urlParams = new URLSearchParams(window.location.search);
    const guid = urlParams.get("guid");
//PowerBiViewer?guid=6dfd6fc5-2dc8-42e3-aa6a-ad05a1fe0606
    api.GetReport(guid, s, e);
  },

  methods: {
    ...mapMutations("breadcrumbService", ["setBreadcrumb"]),
    mobileAndTabletCheck() {
      let check = false;
      // eslint-disable-next-line
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
    next() {
      if (this.EmbedReport.embedReport[0].embedUrl == "") return;

      var target = document.getElementById("target");
      target.data = this.EmbedReport.embedReport[0].embedUrl;

      // const original = document.getElementsByTagName("object")[0];
      // const newFrame = document.createElement("object");
      // newFrame.src = this.EmbedReport.embedReport[0].embedUrl;
      // original.parentNode.replaceChild(newFrame, original);
    },
  },
  computed: {
    rows() {
      return this.tableData.dataSource.length;
    },
  },
};
</script>

<style scoped>

#container-full {
  width: 100%;
  height: 100%;

}

iframe {
  border: 0 hidden !important;
}

</style>